/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { elasticSearchMetaSchema } from './elastic-search-meta';
import { opportunitySearchResultDtoSchema } from './opportunity-search-result-dto';

/** ReadUsersOpportunitiesSearchResponse — dark-roast DTO: SearchUserOpportunityResponseDto */
export const readUsersOpportunitiesSearchResponseSchema = z.object({ "data": z.array(z.lazy(() => opportunitySearchResultDtoSchema)), "meta": z.lazy(() => elasticSearchMetaSchema).nullish() });
export type ReadUsersOpportunitiesSearchResponse = z.infer<typeof readUsersOpportunitiesSearchResponseSchema>;
